import classNames from "classnames";
import StatsCard from "shared/components/statsCard";
import styles from "./styles.module.scss";
import { Icons } from "assets";
import CustomButton from "shared/components/common/customButton";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routeConstant";
import { GetDashboardStatsService } from "shared/services/general";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const DashboardHome = () => {
  const {
    theme: { theme },
  } = useSelector((state: any) => state?.root);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [stats, setStats] = useState<any>(null);
  const handleGetStats = () => {
    setLoading(true);
    GetDashboardStatsService()
      .then(({ data }) => {
        setStats(data);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    handleGetStats();
  }, []);
  return (
    <div className={classNames("flex flex-col gap-5 w-full h-full")}>
      <div className={classNames("flex items-center gap-5 flex-wrap")}>
        <StatsCard
          title1="No. of Active"
          title2="Evaluations"
          value={stats?.active}
          loading={loading}
          Icon={Icons.Clipboard}
          onClick={() => {
            navigate(routeConstant.evaluationRecord.path);
          }}
        />
        <StatsCard
          title1="No. of Draft"
          title2="Evaluations"
          value={stats?.draft}
          loading={loading}
          Icon={Icons.ClipboardWithPencil}
          onClick={() => {
            navigate(routeConstant.draftEvaluation.path);
          }}
        />
        <StatsCard
          title1="No. of Flagged"
          title2="Evaluations"
          value={stats?.flagged}
          loading={loading}
          Icon={Icons.FlagOutline}
          onClick={() => {
            navigate(routeConstant.flagEvaluation.path);
          }}
        />
        <StatsCard
          title1="No. of Evaluations"
          title2="Pending Approval"
          value={stats?.pending}
          loading={loading}
          Icon={Icons.Evaluation}
          onClick={() => {
            navigate(routeConstant.cgpEvaluation.path);
          }}
        />
      </div>
      <div className={classNames(styles.mainContainer, "gap-5 p-5")}>
        {theme === "dark" ? (
          <Icons.EvaluationsDarkIllustration />
        ) : (
          <Icons.EvaluationsLightIllustration />
        )}

        <h1>
          Welcome to <span>RAS</span>track !
        </h1>
        <p>
          The <b>Role Assessment Score (RAS)</b> platform that is designed to streamline your job
          evaluation process. Our intuitive and secure platform makes job
          evaluations straightforward and efficient.
        </p>
        <CustomButton
          title="Start a New Job Evaluation"
          onClick={() => {
            navigate(routeConstant.questionaire.path);
          }}
        />
      </div>
    </div>
  );
};

export default DashboardHome;
